import React, { useState, useRef, useEffect } from 'react';
import styles from './Action.module.css';
import { BsThreeDots } from 'react-icons/bs';

const Action = ({ options = [], onSelect }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState('bottom');
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (showOptions && wrapperRef.current && dropdownRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - wrapperRect.bottom;
      const spaceAbove = wrapperRect.top;

      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        setDropdownPosition('top');
      } else {
        setDropdownPosition('bottom');
      }
    }
  }, [showOptions]);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <div
        className={styles.actionDots}
        onClick={() => setShowOptions((prev) => !prev)}
      >
        <BsThreeDots size={20} />
      </div>

      {showOptions && (
        <div
          ref={dropdownRef}
          className={`${styles.dropdown} ${
            dropdownPosition === 'top' ? styles.top : styles.bottom
          }`}
        >
          {options.map((opt, idx) => (
            <div
              key={idx}
              className={styles.dropdownItem}
              onClick={() => {
                setShowOptions(false);
                onSelect(opt);
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Action;
